import React, { useEffect, useState } from "react";
import { Container, Row, Col, CardBody, Card, Table, Badge, Spinner, Input, Label, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";

const Listings = () => {
  document.title = "Anunțuri | PagaSunt Admin";

  const [loading, setLoading] = useState(true);
  const [listings, setListings] = useState([]);
  const [categories, setCategories] = useState([]);
  const [meta, setMeta] = useState({}); // Pentru paginare
  const [filters, setFilters] = useState({
    listing_id: "",
    keyword: "",
    category_id: "",
    price_min: "",
    price_max: "",
    date_from: "",
    date_to: "",
    status: "",
    payment_status: "",
    page: 1
  });

  const fetchCategories = async () => {
    try {
      const response = await get("/admin/categories");
      if (response.status === "success") {
        setCategories(response.data.flat || []);
      }
    } catch (error) {
      console.error("Eroare la încărcarea categoriilor:", error);
    }
  };

  const fetchListings = async () => {
    setLoading(true);
    try {
      // Construim query string-ul
      const query = `listing_id=${filters.listing_id}&keyword=${filters.keyword}&category_id=${filters.category_id}&price_min=${filters.price_min}&price_max=${filters.price_max}&date_from=${filters.date_from}&date_to=${filters.date_to}&status=${filters.status}&payment_status=${filters.payment_status}&page=${filters.page}`;
      const response = await get(`/admin/listings?${query}`);
      
      if (response.status === "success") {
        setListings(response.data.data);
        setMeta(response.data); // Conține current_page, last_page, etc.
      }
    } catch (error) {
      console.error("Eroare la încărcarea anunțurilor:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchListings();
  }, [filters]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value, page: 1 });
  };

  const handlePageChange = (pageNumber) => {
    setFilters({ ...filters, page: pageNumber });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('ro-RO', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="PagaSunt" breadcrumbItem="Gestionare Anunțuri" />

          {/* Secțiune Filtre */}
          <Card>
            <CardBody>
              <Row>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>ID anunț</Label>
                    <Input
                      type="text"
                      name="listing_id"
                      placeholder="Ex: 123"
                      value={filters.listing_id}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Cuvânt cheie</Label>
                    <Input
                      type="text"
                      name="keyword"
                      placeholder="Caută în titlu și descriere"
                      value={filters.keyword}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Categorie</Label>
                    <Input
                      type="select"
                      name="category_id"
                      value={filters.category_id}
                      onChange={handleFilterChange}
                    >
                      <option value="">Toate</option>
                      {categories.map(category => (
                        <option key={category.id} value={category.id}>
                          {`${"—".repeat(category.depth || 0)}${category.depth ? " " : ""}${category.name}`}
                        </option>
                      ))}
                    </Input>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Status Moderare</Label>
                    <Input type="select" name="status" value={filters.status} onChange={handleFilterChange}>
                      <option value="">Toate</option>
                      <option value="active">Active</option>
                      <option value="pending_moderation">În așteptare</option>
                      <option value="deactivated">Dezactivate</option>
                    </Input>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Status Plată</Label>
                    <Input type="select" name="payment_status" value={filters.payment_status} onChange={handleFilterChange}>
                      <option value="">Toate</option>
                      <option value="paid">Plătite</option>
                      <option value="unpaid">Neplătite</option>
                    </Input>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Preț minim</Label>
                    <Input
                      type="number"
                      name="price_min"
                      min="0"
                      placeholder="Ex: 100"
                      value={filters.price_min}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Preț maxim</Label>
                    <Input
                      type="number"
                      name="price_max"
                      min="0"
                      placeholder="Ex: 1000"
                      value={filters.price_max}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Data minimă</Label>
                    <Input
                      type="date"
                      name="date_from"
                      value={filters.date_from}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label>Data maximă</Label>
                    <Input
                      type="date"
                      name="date_to"
                      value={filters.date_to}
                      onChange={handleFilterChange}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center p-5"><Spinner color="primary" /></div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table-centered table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>ID</th>
                            <th>Imagine</th>
                            <th>Titlu</th>
                            <th>Pret</th>
                            <th>Utilizator</th>
                            <th>Plată</th>
                            <th>Status</th>
                            <th>Data</th>
                            <th>Acțiuni</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listings.map((listing) => (
                            <tr key={listing.id}>
                              <td>#{listing.id}</td>
                              <td>
                                <img src={listing.main_image_url || "placeholder.png"} alt="" className="avatar-sm rounded" style={{ objectFit: 'cover' }} />
                              </td>
                              <td>
                                <h5 className="font-size-14 mb-1 text-truncate" style={{ maxWidth: "200px" }}>{listing.title}</h5>
                                <p className="text-muted mb-0">{listing.category?.name}</p>
                              </td>
                              <td>{listing.price} {listing.currency}</td>
                              <td>{listing.user?.name || listing.user?.phone}</td>
                              <td>
                                <Badge color={listing.payment_status === 'paid' ? 'success' : 'danger'}>
                                  {listing.payment_status === 'paid' ? 'Plătit' : 'Neplătit'}
                                </Badge>
                              </td>
                              <td>
                                <Badge color={listing.status === 'active' ? 'primary' : 'warning'}>
                                  {listing.status === 'active' ? 'Activ' : 'Pending'}
                                </Badge>
                              </td>
                              <td>{formatDate(listing.created_at)}</td>
                              <td>
                                                           <Link 
                               to={`/edit-anunt/${listing.id}`} 
                               className="btn btn-sm btn-soft-primary me-2"
                               title="Editează Anunț"
                             >
                               <i className="uil uil-pen font-size-14"></i>
                             </Link>
                                <button className="btn btn-sm btn-soft-success me-1"><i className="uil uil-check"></i></button>
                                <button className="btn btn-sm btn-soft-danger"><i className="uil uil-trash-alt"></i></button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* Paginare */}
                      <div className="mt-4 d-flex justify-content-center">
                        <Pagination>
                          <PaginationItem disabled={meta.current_page === 1}>
                            <PaginationLink previous onClick={() => handlePageChange(meta.current_page - 1)} />
                          </PaginationItem>
                          {[...Array(meta.last_page)].map((_, i) => (
                            <PaginationItem active={i + 1 === meta.current_page} key={i}>
                              <PaginationLink onClick={() => handlePageChange(i + 1)}>{i + 1}</PaginationLink>
                            </PaginationItem>
                          ))}
                          <PaginationItem disabled={meta.current_page === meta.last_page}>
                            <PaginationLink next onClick={() => handlePageChange(meta.current_page + 1)} />
                          </PaginationItem>
                        </Pagination>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Listings;
